import React from "react";
import { GALLERY, IMAGE_CREDITS } from "../mock/data";
import useReveal from "../hooks/useReveal";

function GalleryItem({ item, i }) {
  const { ref, inView } = useReveal();
  const spanClass =
    item.span === "tall"
      ? "md:row-span-2"
      : item.span === "wide"
      ? "md:col-span-2"
      : "";
  return (
    <div
      ref={ref}
      style={{ animationDelay: `${(i % 4) * 0.08}s` }}
      className={`reveal ${inView ? "in-view" : ""} group relative overflow-hidden ${spanClass}`}
    >
      <img
        src={item.image}
        alt={item.caption}
        className="w-full h-full min-h-[220px] object-cover group-hover:scale-110 transition-transform duration-[900ms]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-70 group-hover:opacity-100 transition-opacity" />
      <div className="absolute bottom-0 left-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        <span className="font-cond uppercase tracking-wider text-sm text-white">
          <span className="baja-red">/</span> {item.caption}
        </span>
      </div>
    </div>
  );
}

export default function GallerySection() {
  return (
    <section id="gallery" className="bg-[#0a0a0a] py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="h-[2px] w-10 bg-baja-red" />
          <span className="font-cond uppercase tracking-[0.25em] text-sm baja-red">Gallery</span>
        </div>
        <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-white max-w-2xl">
          BUILT & LIT BY THE COMMUNITY
        </h2>
        <p className="mt-5 text-white/60 text-lg max-w-xl">
          Real rigs, real riders. A showcase of automotive and motorcycle machines running Baja Designs lighting.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[220px] gap-3 mt-14">
          {GALLERY.map((g, i) => (
            <GalleryItem key={g.id} item={g} i={i} />
          ))}
        </div>

        <p className="mt-8 text-white/35 text-xs max-w-2xl">
          {IMAGE_CREDITS.join(" ")}
        </p>
      </div>
    </section>
  );
}
